module.exports = __webpack_public_path__ + "static/testimonial-portrait.632e13e2.jpg";


//////////////////
// WEBPACK FOOTER
// /tmp/build_2cb81483/src/assets/images/home/testimonial-portrait.jpg
// module id = 1276
// module chunks = 4 5